import React from 'react';
import { isEmpty, cloneDeep } from 'lodash';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { getPageTotalCount } from '../../../utils/utils';
import { writeOffsSort } from '../../../constantsApp';
import { TablePagination, ModalWithItem, AccountHeaderFrom } from '../../../components/common';
import { makeGetListWriteOffs, makePageWriteOffParams, makeErrorMessageWriteOffs } from '../selectors';
import { searchWriteOffs, searchArOpsRequests, getArOpsRequestById } from '../actions';
import { AROperationsSearchForm, AROperationsTable } from '../../../components/ArOperationsHub';
import PageTitle from '../../../components/PageTitle';
import RouteName from '../../App/RouteNames';
import Footer from '../../../components/Footer';
import { makeGetPermissionsArOpsManagement } from '../../App/selectors';
import {
  checkPermissionSearchWriteoff,
  checkPermissionGetWriteoffDetails,
  checkPermissionProcessWriteoff,
  checkPermissionProcessWriteoffReversal,
} from '../CheckPermission';
import ArActivity from '../common/ArActivity';
import ArOperationsForm from '../common/ArOperationsForm';
import { writeOffFieldDetails } from '../constant';

class WriteOffs extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      isActiveNext: true,
      isSearching: false,
      filter: {},
      sort: '',
      sorted: {},
      page: 0,
      size: 20,
      listData: [],
      itemDetailsSelect: null,
      detailsData: {},
      isOpenModalItem: false,
    };
  }

  static getDerivedStateFromProps(props, state) {
    return {
      totalCount: getPageTotalCount({ ...state, items: props.listWriteOffs }),
    };
  }

  componentDidMount() {
    const { location } = this.props;
    if (location && location.state && location.state.filter) {
      this.setState({ filter: location.state.filter }, () => {
        this.doSearchWriteOff();
      });
    } else {
      this.doSearchWriteOff();
    }
  }

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doSearchWriteOff());
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doSearchWriteOff());
  };

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => this.doSearchWriteOff());
  };

  onHandleSearch = filter => {
    this.setState({ filter, isSearching: true, page: 0 }, () => {
      this.doSearchWriteOff();
    });
  };

  doSearchWriteOff = () => {
    const { filter, page, size, sorted } = this.state;
    const { searchArOpsRequests } = this.props;
    const newFilter = cloneDeep(filter);
    newFilter.action = 'WRITEOFF';
    this.setState({ isSearching: true });
    const payload = {
      page: page + 1,
      size,
      filter: newFilter,
      sort: !isEmpty(sorted) ? writeOffsSort[sorted.sortCol][sorted.sortDir] : null,
    };
    searchArOpsRequests(payload, ({ data }) => this.setState({ isSearching: false, listData: data || [] }));
  };

  handleClickReverse = item => {
    const { history } = this.props;
    const { filter } = this.state;
    history.push({
      pathname: RouteName.arOperationsReverseWriteOffs.path,
      state: { writeOffItemSelected: item, filter },
    });
  };

  onToggleModalDetails = () => {
    this.setState({ itemDetailsSelect: null });
  };

  onViewItemDetails = ({ item }) => {
    this.setState({ itemDetailsSelect: item || null });
  };

  onViewRequestDetails = ({ item }) => {
    const { getArOpsRequestById } = this.props;
    getArOpsRequestById(item.id, ({ success, data }) => {
      if (success) this.setState({ isOpenModalItem: true, detailsData: data || {} });
    });
  };

  onToggleModal = () => {
    const { isOpenModalItem } = this.state;
    this.setState({ isOpenModalItem: !isOpenModalItem });
  };

  render() {
    const { listWriteOffs, permissionsArOps, t, searchWriteOffs, location } = this.props;
    const {
      sorted,
      page,
      size,
      totalCount,
      isSearching,
      listData,
      itemDetailsSelect,
      detailsData,
      isOpenModalItem,
      filter,
    } = this.state;

    let modeSearchWriteoff = 0;
    let modeGetWriteoffDetails = 0;
    let modeProcessWriteoff = 0;
    let modeProcessWriteoffReversal = 0;

    if (permissionsArOps && permissionsArOps.arOpsModulePermissions) {
      const listPermission = permissionsArOps.arOpsModulePermissions;
      modeSearchWriteoff = checkPermissionSearchWriteoff({ listPermission });
      modeGetWriteoffDetails = checkPermissionGetWriteoffDetails({ listPermission });
      modeProcessWriteoff = checkPermissionProcessWriteoff({ listPermission });
      modeProcessWriteoffReversal = checkPermissionProcessWriteoffReversal({ listPermission });
    }

    const lastColumns = [];

    const newColumns = [];
    if (modeProcessWriteoffReversal) {
      newColumns.push({
        name: 'Selected',
        label: 'common:label.selected',
        render: (colName, item) => {
          return ['REVERSED'].includes(item.status) || item.action === 'ADJUSTMENT' ? (
            <span />
          ) : (
            <button
              disabled={modeProcessWriteoffReversal === 1}
              // disabled={item.status === 'CLOSED' || modeProcessWriteoffReversal === 1}
              type="button"
              onClick={() => this.handleClickReverse(item)}
              className="button x-small btn-select-next"
            >
              {t('label.reverse')}
            </button>
          );
        },
      });
    }

    if (modeGetWriteoffDetails) {
      newColumns.push({
        name: 'details',
        label: 'common:label.details',
        isRenderT: true,
        render: (colName, item, t) => (
          <button
            className="btn btn-outline-success btn-sm"
            type="button"
            onClick={() => this.onViewItemDetails({ item })}
          >
            {t ? t('common:label.view') : ''}
          </button>
        ),
      });

      newColumns.push({
        name: 'action',
        label: 'common:label.request',
        isRenderT: true,
        render: (colName, item, t) => (
          <button
            className="btn btn-outline-success btn-sm"
            type="button"
            onClick={() => this.onViewRequestDetails({ item })}
          >
            {t ? t('common:label.view') : ''}
          </button>
        ),
      });

      newColumns.push({
        name: 'id',
        label: 'common:label.requestId',
        render: (colName, item) => (
          <button className="text-success no-border" type="button" onClick={() => this.onViewItemDetails({ item })}>
            {item.id || ''}
          </button>
        ),
      });
    }

    return (
      <div className="content-wrapper">
        <PageTitle
          linkTo={
            modeSearchWriteoff === 0 || modeProcessWriteoff === 0
              ? '/'
              : { pathname: RouteName.arOperationsWriteOffsApply.path, state: { filter } }
          }
          titleBtn={
            modeSearchWriteoff === 0 || modeProcessWriteoff === 0 ? t('label.back') : `+ ${t('label.applyWriteOffs')}`
          }
          disabled={modeProcessWriteoff === 1}
          items={[{ name: t('arOperationPage:sidebar.writeOffs'), url: RouteName.arOperationsWriteOffs.path }]}
        />
        <br />
        {modeSearchWriteoff !== 0 && (
          <div>
            <div className="col-md-12 mb-30">
              <div className="card card-statistics h-100">
                <div className="card-body">
                  <div className="repeater-file">
                    <AROperationsSearchForm
                      onSubmit={this.onHandleSearch}
                      defaultFilter={location && location.state && location.state.filter ? location.state.filter : {}}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-12 mb-30">
              <div className="card card-statistics h-100">
                <div className="card-body">
                  <AROperationsTable
                    data={listData}
                    onSort={this.onSortColumn}
                    sorted={sorted}
                    handleClickButton={this.handleClickReverse}
                    modeGetWriteoffDetails={modeGetWriteoffDetails}
                    labelButton="Reverse"
                    isLoading={isSearching}
                    modeProcessWriteoffReversal={modeProcessWriteoffReversal}
                    linkDetail={RouteName.arOperationsWriteOffsDetails.path}
                    defaultLabelType="label.writeOffType"
                    isWriteOff
                    newColumns={[
                      ...newColumns,
                      {
                        name: 'parentId',
                        label: 'common:label.writeoffId',
                      },
                    ]}
                    newLastColumns={lastColumns}
                  />
                </div>
              </div>
            </div>
            <div className="mb-30">
              <TablePagination
                pageNumber={page}
                pageSize={size}
                totalCount={totalCount}
                onPageChange={this.onPageChange}
                onSizeChange={this.onSizeChange}
              />
            </div>
          </div>
        )}
        <Footer className="footer-bottom" />
        <ModalWithItem
          wrapperClass="modal-70 modal-custom"
          modalTitle={t('label.writeOffRequestDetails')}
          isOpen={isOpenModalItem}
          onToggle={this.onToggleModal}
        >
          <AccountHeaderFrom accountNum={detailsData?.accountId || ''} />
          <div className="col-md-12 mb-30 mt-3">
            <ArOperationsForm
              listFields={writeOffFieldDetails}
              data={detailsData}
              isDisabledAllField
              onChange={() => {}}
              onCancel={this.onToggleModal}
            />
          </div>
        </ModalWithItem>
        <ModalWithItem
          wrapperClass="modal-70 modal-custom"
          modalTitle={t('label.writeOffDetail')}
          isOpen={!!itemDetailsSelect}
          onToggle={this.onToggleModalDetails}
        >
          <AccountHeaderFrom accountNum={itemDetailsSelect?.id} />
          <div className="col-md-12 mb-30">
            <ArActivity
              id={itemDetailsSelect?.id}
              type={
                itemDetailsSelect?.type && itemDetailsSelect?.type === 'UNBILLED_LINE_ADJUSTMENT'
                  ? 'UNBILLED_LINE_ADJUSTMENT'
                  : null
              }
              onCancel={this.onToggleModalDetails}
              searchData={searchWriteOffs}
            />
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

WriteOffs.propTypes = {
  listWriteOffs: PropTypes.arrayOf(PropTypes.objectOf),
  history: PropTypes.objectOf(PropTypes.any),
  searchArOpsRequests: PropTypes.func.isRequired,
  getArOpsRequestById: PropTypes.func.isRequired,
  permissionsArOps: PropTypes.objectOf(PropTypes.any),
};

WriteOffs.defaultProps = {
  listWriteOffs: [],
  history: {},
  permissionsArOps: {},
};

const mapStateToProps = createStructuredSelector({
  listWriteOffs: makeGetListWriteOffs() || [],
  params: makePageWriteOffParams() || {},
  errorMessage: makeErrorMessageWriteOffs() || '',
  permissionsArOps: makeGetPermissionsArOpsManagement() || {},
});
export default withTranslation('common')(
  connect(mapStateToProps, { searchWriteOffs, searchArOpsRequests, getArOpsRequestById })(withRouter(WriteOffs))
);
